import styled from "styled-components";


export const DragOnDrop = styled.div`
    display: block !important;
    width: 68%;
    padding: 8px px 16px;
    line-height: 25px;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    border-radius: 6px;
    -webkit-appearance: none;
    color: #757575;
    border: 1px solid transparent;
    background: #f8f8f8;
    transition: border 0.3s ease;


    :placeholder { 
    color: #757575;
    opacity: 1; /* Firefox */
  }
  

  .btnSend{
    width: 33%;
    height: 51px;
  }

    div {
      width: 100%;
      height: 51px;
      display: grid;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor:pointer;
    }

    div img {
        display: flex;
        margin: 33px auto 17px auto;
        width: 38px;
    }

    div p {
        margin: 0px auto 0px auto;
        font-size: 12px;
        color: #757575;
    }
    @media (max-width: 600px){
    div p {
      text-align:center;
    }
  }

    div p:hover{
      margin: 0px auto 0px auto;
      font-size: 12px;
      color: #757575;
  }
    
    @media (max-width: 600px){
        width: 100%;
        height: 100%;

        div img {
            display: flex;
            margin: 9px auto 17px auto;
         
        }
    }

`;